/*
 * @Date: 2022-07-04 19:04:50
 * @LastEditors: hanhuixian hanhuixian@lxrental.com
 */
export default {
  namespaced: true,

  state: () => ({
    langType: 'en' // 默认语言类型
  }),

  mutations: {
    // 设置语言类型
    set(state,payload) {
      state.langType = payload
    }
  }
}